import Types from '../Types'
import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

export const INITIAL_STATE = Immutable({
  error: null,
  loading: false,
  viewportWidth: 0,
  viewportHeight: 0
})

const ACTION_HANDLERS = {
  [Types.SAVE_SEARCH_STATE]: (state, action) =>
    state.merge({ searchState: action.searchState }),
  WINDOW_RESIZE: (state, { viewportWidth, viewportHeight }) =>
    state.merge({ viewportWidth, viewportHeight }),
  PRODUCT_MODAL_OPEN: (state, { productKey, amount, closeHidden }) =>
    state.merge({
      modalVisible: true,
      modalProductKey: productKey,
      modalProductAmount: amount,
      modalCloseHidden: closeHidden
    }),
  PRODUCT_MODAL_CLOSE: (state) =>
    state.merge({
      modalVisible: false,
      modalProductKey: null,
      modalProductAmount: 0
    }),
  PRODUCT_MODAL_KEY_CHANGED: (state, { productKey, amount }) =>
    state.merge({
      modalProductKey: productKey,
      modalProductAmount: amount
    })
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



/** WEBPACK FOOTER **
 ** ./src/redux/app/appReducer.js
 **/